import styled from "styled-components";
import {
  TimerControllerBackgroundBox,
  TimerControllerBox,
} from "../../../style";

export const ControllerSitInWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 1587px;
  min-width: 0;
`;

export const ControllerSitInContentWrapper = styled(
  TimerControllerBackgroundBox,
)`
  padding: 40px 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  flex: 1;
`;

export const ControllerSitInHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ControllerSitInHeaderButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;

  > .text {
    border-radius: 10px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    color: #fff;
    padding: 0 15px;
    white-space: nowrap;
    cursor: pointer;
  }

  > .button {
    width: 75px;
    height: 40px;
    border-radius: 10px;
    background: #7f25fb;
    color: #ffffff;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 18px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
`;

export const ControllerSitInHeaderInputWrapper = styled.div`
  width: 300px;
  height: 40px;
  border-radius: 15px;
  padding: 10px 15px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-right: 12px;

  > input {
    outline: none;
    width: 100%;
    height: 100%;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    background: transparent;
    border: none;
    color: #fff;
  }

  > img {
    cursor: pointer;
  }
`;

export const ControllerSitInMemberListWrapper = styled(TimerControllerBox)`
  position: relative;
  flex-direction: column;
  justify-content: normal;
  align-items: normal;
  gap: 12px;
  height: 460px;
  border-radius: 20px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(5px);
  .name {
    width: 18%;
  }

  .count {
    width: 15%;
    white-space: nowrap;
  }

  .button {
    width: 13%;
  }

  .more {
    width: 5%;
  }

  .return {
    width: 45%;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    box-sizing: border-box;
    padding-right: 15px;
    cursor: pointer;
  }
`;

export const ControllerSitInSortWrapper = styled.div<{ isAbsolute: boolean }>`
  position: ${(p) => (p.isAbsolute ? "absolute" : "relative")};
  top: ${(p) => (p.isAbsolute ? "20px" : "0")};
  right: ${(p) => (p.isAbsolute ? "20px" : "0")};
  color: #fff;
  z-index: 50;

  > .box {
    width: 114px;
    height: 30px;
    border-radius: 15px;
    padding: 8px 0;
    box-sizing: border-box;
    border: 1px solid var(--Black-100, #f0f0f0);
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

export const ControllerSitInMemberListHeaderWrapper = styled.div`
  display: flex;
  gap: 27px;
  padding: 45px 20px 0;
`;

export const ControllerSitInMemberListHeader = styled.div`
  flex: 1;
  display: flex;
  gap: 6px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  text-align: center;
  padding: 0 10px;
  box-sizing: border-box;
`;

export const ControllerSitInMemberListBody = styled.div`
  padding: 0 20px 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 27px;
  height: 100%;
  overflow-y: auto;
  align-content: start;
  scrollbar-width: none;
`;

export const ControllerSitInMemberListItem = styled.div`
  flex: 1;
  height: 50px;
  border-radius: 14.71px;
  padding: 5px 10px;
  background: #e5e5e5;
  color: #000;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  cursor: pointer;

  > .button {
    height: 34px;
    border-radius: 9.78px;
    background: #7f25fb;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }

  > .more {
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: relative;

    > img {
      height: 40px;
      width: auto;
    }
  }
`;

export const ControllerSitInButtonGroup = styled.div<{
  bottom?: string;
  width?: string;
  buttonWidth?: string;
}>`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: ${(p) => (p.bottom ? p.bottom : "23.5px")};
  width: ${(p) => (p.width ? p.width : "calc(100% - 30px)")};

  > .button {
    width: ${(p) => (p.buttonWidth ? p.buttonWidth : "100%")};
    height: 48px;
    border-radius: 8px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
    color: #6436e7;
    cursor: pointer;
  }

  > .purple {
    background: #6436e7;
    color: #fff;
  }

  > .gray {
    background: #bebebe;
    color: #fff;
  }
`;
